import { NextPageContext } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Article, { Roles, Types } from 'models/Article';
import ArticleCategory from 'models/ArticleCategory';
import CmsPage from 'models/CmsPage';

import { list as listArticles } from 'requests/articles';
import { list as listArticlesCategories } from 'requests/articlesCategories';
import { single as singleCmsPage } from 'requests/cmsPages';

import Component from './component';
import { ArticleGroup, Props } from './types';

Component.getInitialProps = async (appContext: NextPageContext): Promise<Props> => {
    let articleCategories: ListCollection<ArticleCategory> = null;
    const articles: ArticleGroup[] = [];
    let tutorials: ListCollection<Article>;
    let cmsPage: CmsPage = null;

    try {
        await Promise.all([
            listArticlesCategories({ page: 1, perPage: 999 }),
            listArticles({ role: Roles.Worker, page: 1, perPage: 6, categorySlug: 'szkolenia' }),
            singleCmsPage({ slug: 'articlesemployeelist-baza-wiedzy' }),
        ]).then(responses => {
            articleCategories = responses[0];
            tutorials = responses[1];
            cmsPage = responses[2];
        });

        articleCategories = await listArticlesCategories();
        tutorials =  await listArticles({ type: Types.Video });

        // TODO: Refactor
        for (const articleCategoryIndex in articleCategories?.elements) {
            const articleCategory = articleCategories?.elements[articleCategoryIndex];

            const articleGroup: ArticleGroup = {
                category: articleCategory,
                elements: await listArticles({ categorySlug: articleCategory?.slug, type: Types.Default }),
            };

            articles.push(articleGroup);
        }
    } catch (error) {
        console.error(error);
    }

    return {
        articleCategories: articleCategories.elements || null,
        articles,
        tutorials: tutorials.elements || null,
        cmsPage: cmsPage || null,
    };
};

export default Component;
